import { defineMessages } from 'react-intl';

export const bypassBlockMessages = defineMessages({
  basicFilterValueList: {
    id: 'basicFilter.valueList.bypass.headline',
    defaultMessage: 'Filteroptionen zu Filter {filterName} überspringen',
  },
  basicFilterValueGroup: {
    id: 'basicFilter.valueGroup.bypass.headline',
    defaultMessage: '{filterGroupName} überspringen',
  },
});
